/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RequestAccessResult = {
  /**
   * Number of administrators who were notified.
   */
  sentToCount: number;
};

/** @internal */
export const RequestAccessResult$inboundSchema: z.ZodMiniType<
  RequestAccessResult,
  unknown
> = z.pipe(
  z.object({
    sent_to_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "sent_to_count": "sentToCount",
    });
  }),
);

export function requestAccessResultFromJSON(
  jsonString: string,
): SafeParseResult<RequestAccessResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RequestAccessResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RequestAccessResult' from JSON`,
  );
}
